import { render, staticRenderFns } from "./WonderTopicCoreHistory.vue?vue&type=template&id=41dcf4d3&scoped=true"
import script from "./WonderTopicCoreHistory.vue?vue&type=script&lang=js"
export * from "./WonderTopicCoreHistory.vue?vue&type=script&lang=js"
import style0 from "./WonderTopicCoreHistory.vue?vue&type=style&index=0&id=41dcf4d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dcf4d3",
  null
  
)

export default component.exports